const RECOVERY_KEY_PREFIX = 'vendor-ach-account-collection'

export const vendorAccountCollectionRecoveryKey = (
  organizationId: string,
): string => `${RECOVERY_KEY_PREFIX}:${organizationId}`

const sessionStorageOrNull = (): Storage | null => {
  if (typeof window === 'undefined') return null
  try {
    return window.sessionStorage
  } catch {
    return null
  }
}

export const getRecoverableVendorId = (
  organizationId: string,
): string | null => {
  if (!organizationId.trim()) return null
  const vendorId = sessionStorageOrNull()?.getItem(
    vendorAccountCollectionRecoveryKey(organizationId),
  )
  return vendorId?.trim() || null
}

export const rememberRecoverableVendor = (
  organizationId: string,
  vendorId: string,
): void => {
  if (!organizationId.trim() || !vendorId.trim()) return
  sessionStorageOrNull()?.setItem(
    vendorAccountCollectionRecoveryKey(organizationId),
    vendorId,
  )
}

export const clearRecoverableVendor = (
  organizationId: string,
  vendorId?: string,
): void => {
  const storage = sessionStorageOrNull()
  if (!storage || !organizationId.trim()) return
  const key = vendorAccountCollectionRecoveryKey(organizationId)
  if (vendorId && storage.getItem(key) !== vendorId) return
  storage.removeItem(key)
}
